import { Spin as AntdSpin, type SpinProps } from 'antd'
import type { FC } from 'react'
import { IconContext } from 'react-icons'
import { AiOutlineLoading } from 'react-icons/ai'
import styled from 'styled-components'

export const Spin: FC<SpinProps> = (props) => {
  return (
    <AntdSpin
      indicator={
        <IconContext.Provider value={{ color: '#20a0ff', size: '42px' }}>
          <StyledLoadingIcon />
        </IconContext.Provider>
      }
      {...props}
    />
  )
}

const StyledLoadingIcon = styled(AiOutlineLoading)`
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`
